import { useFetcher } from '@lyrahealth-inc/ui-core-crossplatform/src/hooks/useFetcher'

type FetchAction = (...args: unknown[]) => Promise<unknown>

export type HPEligibilityResponse = {
  speciality_care_attestation_status?: string
  next_session_uses_health_plan?: boolean
  payment_type?: string
}

export const useEndOfSessionRequests = ({
  getHPEligibility,
  getICD10s,
  getContentsByProgramId,
  healthPlanEligibilityPayload,
  sessionType,
  programId,
  shouldFetchContents,
}: {
  getHPEligibility: FetchAction
  getICD10s: FetchAction
  getContentsByProgramId: FetchAction
  healthPlanEligibilityPayload: Record<string, unknown>
  sessionType?: string
  programId?: string
  shouldFetchContents: boolean
}) => {
  // useFetcher no-ops a call whose args still contain an undefined value, and only
  // retries when one of its deps changes. sessionType is derived from the episode and
  // the provider's rates, which can resolve before the appointment being closed does -
  // and then the eligibility check never runs at all. Depend on the appointment fields
  // of the payload too, so the call is made as soon as the payload is complete.
  const [isLoadingHPEligibility, eligibilityResponse, hasFetchedHPEligibility] = useFetcher(
    [getHPEligibility, healthPlanEligibilityPayload, !!sessionType],
    [sessionType, healthPlanEligibilityPayload.appointment_id, healthPlanEligibilityPayload.visit_date],
  )
  const [isLoadingSessionMetadata, , hasFetchedSessionMetadata] = useFetcher(
    [[getICD10s], [getContentsByProgramId, { programId }, shouldFetchContents]],
    [sessionType],
  )

  return {
    isLoadingHPEligibility,
    isLoadingSessionMetadata,
    eligibilityObj: (eligibilityResponse ?? {}) as HPEligibilityResponse,
    hasFetchedHPEligibility,
    hasFetchedSessionMetadata,
  }
}
